import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./DocumentManagement.css";
import DocumentOverview from "./DocumentOverview";
import BannerImage from "../../../assets/other_image/document_managemant.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
const DocumentManagement = () => {
  

  return (
    <section className="document-management">
        
      
        <Banner
        image={BannerImage} // Pass the image for this page
        heading="Teamcenter Document Management" // Pass the heading text for this page
      />
       
      <div>
         <FloatingContactUs />
      </div>
      
        <DocumentOverview />
        <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
        <h4 className="document-page-heading">Unlock the Power :</h4>
        <h5 className="document-subheading">
          Discover the Transformative Benefits of Document Management with NexTech !
        </h5>
        <ul className="custom-bullets">
          <li>Improved accuracy and consistency of information</li>
          <li>Optimized processes for authoring and managing documents</li>
          <li>
            Standardized authoring process for engineering as well as pure document management authors
          </li>
          <li>Reduced total document management costs</li>
        </ul>
      </div>
      </section>

<section>
  <div className="solutions container">
    <div className="solutions-content">
      <div className="row">
        <div className="col-md-6 col-12">
          <h4 className="document-page-heading">Teamcenter Solutions</h4>
          <ul className="custom-bullets">
          <li>MS office Integration </li>
          <li>Google Doc Management </li>
          <li>Standalone office integration </li>
          <li>Document Management </li>
          <li>Document rendering </li>
          <li>Dispatcher  </li>
          <li>IRDC </li>
          </ul>
        </div>

        <div className="col-md-6 col-12">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
            <li><NavLink to={"/teamcenter/ecad-integration"} >ECAD Integration</NavLink></li>
            <li><NavLink to={"/teamcenter/mcad-integration"} >MCAD Integration</NavLink></li>
              <li><NavLink to={"/teamcenter/cybersecurity"} >Teamcenter Cyber security</NavLink></li>
              <li><NavLink to={"/teamcenter/manufacturing-data-process-management"} >Manufacturing Data and Process Management</NavLink></li>     
              <li><NavLink to={"/teamcenter/plm-erp-data-process-management"} >PLM - ERP (SAP, Oracle, HANA) Data and Process Management
              </NavLink></li>
              <li><NavLink to={"/teamcenter/product-bom-variability-management"} >Product BOM and Variability Management</NavLink></li>
              <li><NavLink to={"/teamcenter/program-project-management"} >Teamcenter Project Management</NavLink></li>
              <li><NavLink to={"/teamcenter/business-process-management"} >Business Process And Change Management
              </NavLink></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      <section style={{ background: "#f5f7fa" }}>
      <div className="why-nextech container">
        <h4 className="document-page-heading">Why NexTech?</h4>
        <h5 className="document-subheading">For Document Management</h5>
        <ul className="custom-bullets">
          <li>
          Teamcenter implementation establishes integrated IP backbone for efficient document lifecycle management. 
          </li>
          <li>
          Expertise in Item Revision Definition Configuration ensures accurate rendering and digital signing of files. 
          </li>
          <li>
          Solutions include Office online integration, standalone office integration, and document rendering. 
          </li>
          <li>
          Dispatcher facilitates streamlined document routing and management. 
          </li>
          <li>
          Standardized authoring processes optimize efficiency for engineering and document management authors. 
          </li>
        </ul>
      </div>
      </section>
      <Letsgetintouch />

    </section>
  );
};

export default DocumentManagement;
